/*!
 * Simple Age Verification (https://github.com/Herudea/age-verification))
 */

var modal_content,
modal_screen;

// Start Working ASAP.
$(document).ready(function() {
	av_legality_check();
});


av_legality_check = function() {
	if ($.cookie('is_legal') == "yes") {
		// legal!
		// Do nothing?
	} else {
		av_showmodal();

		// Make sure the prompt stays in the middle.
		$(window).on('resize', av_positionPrompt);
	}
};

av_showmodal = function() {
	modal_screen = $('<div id="modal_screen"></div>');
	modal_content = $('<div id="modal_content" style="display:none"></div>');
	var modal_content_wrapper = $('<div id="modal_content_wrapper" class="content_wrapper"></div>');
	var modal_regret_wrapper = $('<div id="modal_regret_wrapper" class="content_wrapper" style="display:none;"></div>');

	// Question Content
	var content_heading = $('<div class="content_wrapper_inner"><div class="age_left"><div class="modal_logo"><img src="https://cdn.shopify.com/s/files/1/1000/1865/1462/files/logo-inverse_cb19128e-49b3-424d-98dd-a127adf271a2.png?v=1779113163" alt="Drinksology. Kirker Greer. Innovation in spirit."></div><p>Are you of legal drinking age?</p></div><div class="yesno"><ul><li><a href="#nothing" class="av_btn av_go" rel="yes">Yes</a></li><li><a href="#nothing" class="av_btn av_no" rel="no">No</li></div></div>');
	var content_buttons = $('');

	// Regret Content
	var regret_heading = $('<div class="content_wrapper_inner"><div class="age_left"><div class="modal_logo"><img src="https://cdn.shopify.com/s/files/1/1000/1865/1462/files/logo-inverse_cb19128e-49b3-424d-98dd-a127adf271a2.png?v=1779113163" alt="Drinksology. Kirker Greer. Innovation in spirit."></div><h2>We\'re Sorry!</h2> <p>You must be at least the legal drinking age of your country of residence to view this site.</p></div></div>');
	var regret_buttons = $('<p>I hit the wrong button!</p> <div class="yesno"><ul><li><a href="#nothing" class="av_btn av_go" rel="yes">I\'m old enough!</a></li></ul></div>');

	modal_content_wrapper.append(content_heading, content_buttons);
	modal_regret_wrapper.append(regret_heading);
	modal_content.append(modal_content_wrapper, modal_regret_wrapper);

	// Append the prompt to the end of the document
	$('body').append(modal_screen, modal_content);

	// Center the box
	av_positionPrompt();

	modal_content.find('a.av_btn').on('click', av_setCookie);
};

av_setCookie = function(e) {
	e.preventDefault();

	var is_legal = $(e.currentTarget).attr('rel');

	$.cookie('is_legal', is_legal, {
		//expires: 0,
		path: '/'
	});

	if (is_legal == "yes") {
		av_closeModal();
		$(window).off('resize');
	} else {
		av_showRegret();
	}
};

av_closeModal = function() {
	modal_content.fadeOut();
	modal_screen.fadeOut();
};

av_showRegret = function() {
	modal_screen.addClass('nope');
	modal_content.find('#modal_content_wrapper').hide();
	modal_content.find('#modal_regret_wrapper').show();
};

av_positionPrompt = function() {
	var top = ($(window).outerHeight() - $('#modal_content').outerHeight()) / 2;
	var left = ($(window).outerWidth() - $('#modal_content').outerWidth()) / 2;
	modal_content.css({
		//'top': top,
		'left': left
	});

	if (modal_content.is(':hidden') && ($.cookie('is_legal') != "yes")) {
		modal_content.fadeIn('slow')
	}
};